import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const RabItemsWrapper = styled('div', { label: 'RabItemsWrapper' })`
    margin-bottom: 10px;
`;

export const RabItemsWrapperSelection = withConfig(theme => styled('span', { label: 'RabItemsWrapperSelection' })`
    display: block;
    font-size: ${theme.star.fontSize.xRegular};
    line-height: 1;
`);

export const RabItemsWrapperMarket = withConfig(theme => styled(RabItemsWrapperSelection, { label: 'RabItemsWrapperMarket' })`
    font-size: ${theme.star.fontSize.xSmall};
    margin-top: 5px;
    opacity: 0.6;
`);
